module.exports = __webpack_public_path__ + "media/images/events-icon-12cb0e76749aa332f9db40f74ed8a34a.svg";